// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_wpIY9 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: var(--white-background);
  color: #000000;
  border-top: 1px solid #e5e5e5;
  width: 100%;
  height: 50px;
  box-sizing: border-box;

  @media (width <=800px) {
    align-items: center;
    flex-direction: column;
  }

  a {
    color: #000000;
    text-decoration: none;
    font-size: 14px;
  }

  .flags_cXXM_{
    height: 100%;
  }

  .languageHover_qW8IV{
    display: flex;
    gap: 10px;
    align-items: center;
    height: 100%;
    font-size: 14px;
    .icon_I1Pkb {
      height: 12px;
      width: 12px;
    }
  }
  .language_mzSay {
    display: flex;
    height: 100%;
    align-items: center;
  }

  .languagecontainer_PzfCH {
    position: relative;
    &:hover {
      .languageDropdown_Ty8u_ {
        display: flex;
      }
    }

    .languageDropdown_Ty8u_ {
      position: absolute;
      display: none;
      bottom: calc(100% );
      right: 10px;
      flex-direction: column;
      background: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(10px);

      border-radius: 8px;
      box-shadow: 0 2px 10px var(--_0000001a-shadow);
      padding: 4px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
      .dropdownItem_gDNK_ {
        margin: 0;
        list-style: none;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #333;
        box-sizing: border-box;
        width: 100%;
        padding: 8px;
        border: none;
        background: none;
        text-align: left;
        cursor: pointer;
        font-size: 14px;
        border-radius: 4px;
        transition: background-color 0.2s ease-in-out;
        -webkit-transition: background-color 0.2s ease-in-out;
        -moz-transition: background-color 0.2s ease-in-out;
        -ms-transition: background-color 0.2s ease-in-out;
        -o-transition: background-color 0.2s ease-in-out;

        &:hover {
          background-color: var(--f5-background);
        }
        svg {
          width: 20px;
          height: 20px;
          border-radius: 6px;
          -webkit-border-radius: 6px;
          -moz-border-radius: 6px;
          -ms-border-radius: 6px;
          -o-border-radius: 6px;
        }
      }
    }
  }

  .leftSection_z3qO8,
  .rightSection_fxZO9 {
    display: flex;
    align-items: center;
    gap: 15px;
    height: 100%;
    .name_uxKjz{
      text-transform: capitalize;
    }
  }

  @media (width <=768px) {
    .rightSection_fxZO9 {
      display: grid;
      margin-bottom: 20px;
      width: 100%;
      grid-template-columns: 1fr 1fr;
      margin-top: 10px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/FooterLanding/FooterLanding.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,sBAAsB;;EAEtB;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf;MACE,YAAY;MACZ,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB;MACE;QACE,aAAa;MACf;IACF;;IAEA;MACE,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,WAAW;MACX,sBAAsB;MACtB,oCAAoC;MACpC,2BAA2B;;MAE3B,kBAAkB;MAClB,8CAA8C;MAC9C,YAAY;MACZ,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB;QACE,SAAS;QACT,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,WAAW;QACX,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,kBAAkB;QAClB,6CAA6C;QAC7C,qDAAqD;QACrD,kDAAkD;QAClD,iDAAiD;QACjD,gDAAgD;;QAEhD;UACE,sCAAsC;QACxC;QACA;UACE,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,0BAA0B;UAC1B,uBAAuB;UACvB,sBAAsB;UACtB,qBAAqB;QACvB;MACF;IACF;EACF;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE;MACE,aAAa;MACb,mBAAmB;MACnB,WAAW;MACX,8BAA8B;MAC9B,gBAAgB;IAClB;EACF;AACF","sourcesContent":[".footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  background-color: var(--white-background);\n  color: #000000;\n  border-top: 1px solid #e5e5e5;\n  width: 100%;\n  height: 50px;\n  box-sizing: border-box;\n\n  @media (width <=800px) {\n    align-items: center;\n    flex-direction: column;\n  }\n\n  a {\n    color: #000000;\n    text-decoration: none;\n    font-size: 14px;\n  }\n\n  .flags{\n    height: 100%;\n  }\n\n  .languageHover{\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    height: 100%;\n    font-size: 14px;\n    .icon {\n      height: 12px;\n      width: 12px;\n    }\n  }\n  .language {\n    display: flex;\n    height: 100%;\n    align-items: center;\n  }\n\n  .languagecontainer {\n    position: relative;\n    &:hover {\n      .languageDropdown {\n        display: flex;\n      }\n    }\n\n    .languageDropdown {\n      position: absolute;\n      display: none;\n      bottom: calc(100% );\n      right: 10px;\n      flex-direction: column;\n      background: rgba(255, 255, 255, 0.7);\n      backdrop-filter: blur(10px);\n\n      border-radius: 8px;\n      box-shadow: 0 2px 10px var(--_0000001a-shadow);\n      padding: 4px;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      .dropdownItem {\n        margin: 0;\n        list-style: none;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        color: #333;\n        box-sizing: border-box;\n        width: 100%;\n        padding: 8px;\n        border: none;\n        background: none;\n        text-align: left;\n        cursor: pointer;\n        font-size: 14px;\n        border-radius: 4px;\n        transition: background-color 0.2s ease-in-out;\n        -webkit-transition: background-color 0.2s ease-in-out;\n        -moz-transition: background-color 0.2s ease-in-out;\n        -ms-transition: background-color 0.2s ease-in-out;\n        -o-transition: background-color 0.2s ease-in-out;\n\n        &:hover {\n          background-color: var(--f5-background);\n        }\n        svg {\n          width: 20px;\n          height: 20px;\n          border-radius: 6px;\n          -webkit-border-radius: 6px;\n          -moz-border-radius: 6px;\n          -ms-border-radius: 6px;\n          -o-border-radius: 6px;\n        }\n      }\n    }\n  }\n\n  .leftSection,\n  .rightSection {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    height: 100%;\n    .name{\n      text-transform: capitalize;\n    }\n  }\n\n  @media (width <=768px) {\n    .rightSection {\n      display: grid;\n      margin-bottom: 20px;\n      width: 100%;\n      grid-template-columns: 1fr 1fr;\n      margin-top: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `footer_wpIY9`,
	"flags": `flags_cXXM_`,
	"languageHover": `languageHover_qW8IV`,
	"icon": `icon_I1Pkb`,
	"language": `language_mzSay`,
	"languagecontainer": `languagecontainer_PzfCH`,
	"languageDropdown": `languageDropdown_Ty8u_`,
	"dropdownItem": `dropdownItem_gDNK_`,
	"leftSection": `leftSection_z3qO8`,
	"rightSection": `rightSection_fxZO9`,
	"name": `name_uxKjz`
};
export default ___CSS_LOADER_EXPORT___;
